var map = {
	"./instagram-hover.svg": 5217,
	"./instagram.svg": 5392,
	"./mail-hover.svg": 7371,
	"./mail.svg": 2711,
	"./telegram-hover.svg": 4787,
	"./telegram.svg": 4718,
	"./vk-hover.svg": 9474,
	"./vk.svg": 933,
	"./yandex-music-hover.svg": 1631,
	"./yandex-music.svg": 3187,
	"./youtube-hover.svg": 8051,
	"./youtube.svg": 6159
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2107;